import React from 'react';
import LandingPageView from '../pages/LandingPageView';

const LandingPagePreview = ({ formData, documents = [], projects = [] }) => {
  // Form verilerinden önizleme için gerekli verileri hazırla
  const previewData = {
    _id: 'preview',
    title: formData.title || 'Your App Title',
    description: formData.description || 'Brief description of your app',
    customUrl: formData.customUrl || 'preview',
    theme: formData.theme,
    project: (() => {
      const selectedProject = projects.find(p => p._id === formData.projectId);
      if (selectedProject) {
        return {
          _id: selectedProject._id,
          name: selectedProject.name,
          description: selectedProject.description,
          logo: selectedProject.logo || '/default-project.png',
          packageName: selectedProject.packageName || 'com.example.app',
          appStoreId: selectedProject.appStoreId || '123456789'
        };
      }
      return {
        _id: 'preview-project',
        name: formData.title || 'Your App',
        description: formData.description || 'Brief description of your app',
        logo: '/default-project.png',
        packageName: 'com.example.app',
        appStoreId: '123456789'
      };
    })(),
    products: [
      {
        _id: 'preview-android',
        name: 'Android App',
        platform: 'android',
        appStoreLinks: {
          googlePlay: 'https://play.google.com/store/apps/details?id=com.example.app'
        }
      },
      {
        _id: 'preview-ios',
        name: 'iOS App', 
        platform: 'ios',
        appStoreLinks: {
          appStore: 'https://apps.apple.com/app/id123456789'
        }
      }
    ],
    supportModule: formData.supportModuleId ? {
      _id: formData.supportModuleId,
      isActive: true
    } : null,
    selectedDocuments: (() => {
      if (!formData.selectedDocuments) return [];
      
      const selectedDocIds = Object.values(formData.selectedDocuments).filter(id => id);
      return selectedDocIds.map(docId => {
        const doc = documents.find(d => d._id === docId);
        if (doc) {
          // Backend'den gelen format gibi hazırla
          let displayName = doc.title || doc.name;
          if (doc.documentType === 'privacy_policy') displayName = 'Privacy Policy';
          else if (doc.documentType === 'terms_of_service') displayName = 'Terms of Service';
          else if (doc.documentType === 'disclaimer') displayName = 'Disclaimer';
          else if (doc.documentType === 'cookie_policy') displayName = 'Cookie Policy';
          else if (doc.documentType === 'refund_policy') displayName = 'Refund Policy';
          else if (doc.documentType === 'data_processing_agreement') displayName = 'Data Processing Agreement';
          
          return {
            _id: doc._id,
            name: displayName,
            description: doc.companyName || doc.description,
            fileUrl: doc.fileUrl || '#',
            type: doc.documentType
          };
        }
        return {
          _id: docId,
          name: 'Document',
          description: '',
          fileUrl: '#',
          type: 'unknown'
        };
      });
    })()
  };

  // Gerçek LandingPageView componentini kullan, ancak preview modunda
  return (
    <div className="preview-container w-full h-full overflow-auto" style={{ minHeight: '600px' }}>
      <LandingPageView 
        landingPage={previewData}
        isPreview={true}
      />
    </div>
  );
};

export default LandingPagePreview;
